import {takeEvery} from "redux-saga/effects";
import {authActions} from "./auth.slice";
import {loadSessionSaga} from "./_sagas/loadSession.saga";
import {signInWithGoogleSaga} from "./_sagas/signInWithGoogle.saga";
import {signOutSaga} from "./_sagas/signOut.saga";

export function* authSaga() {
    yield takeEvery(authActions.loadSession.type, loadSessionSaga);
    yield takeEvery(authActions.signInWithGoogle.type, signInWithGoogleSaga);
    yield takeEvery(authActions.signOut.type, signOutSaga);
}
